import { useEffect, useState } from "react";
import { Alert, Button, Drawer, Form, Input, message, Switch } from "antd";
import service from "../../api/FetchInterceptor";
import RichTextEditor from "../../components/richTextEditor";

const PartForm = ({ formationId, part = null, open, setOpen, onSuccess }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const isEdit = !!part;

    useEffect(() => {
        if (!open) {
            form.resetFields();
            return;
        }

        if (isEdit) {
            // On recharge la partie pour avoir le contenu à jour.
            service({ method: "GET", url: `admin/formations/${formationId}/parts/${part.id}` }).then((data) =>
                form.setFieldsValue({
                    title: data.title,
                    content: data.content ?? "",
                    is_free_preview: data.is_free_preview,
                })
            );
        } else {
            form.setFieldsValue({ title: "", content: "", is_free_preview: false });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, part?.id]);

    const onSubmit = (values) => {
        setLoading(true);

        service({
            method: isEdit ? "PUT" : "POST",
            url: isEdit
                ? `admin/formations/${formationId}/parts/${part.id}`
                : `admin/formations/${formationId}/parts`,
            data: {
                title: values.title,
                content: values.content ?? "",
                is_free_preview: !!values.is_free_preview,
            },
        })
            .then(() => {
                message.success(isEdit ? "Partie mise à jour" : "Partie ajoutée");
                setOpen(false);
                onSuccess?.();
            })
            .catch((e) => {
                const errors = e?.response?.data?.errors;
                message.error(errors ? Object.values(errors).flat()[0] : "Erreur lors de l'enregistrement");
            })
            .finally(() => setLoading(false));
    };

    return (
        <Drawer
            title={isEdit ? "Modifier la partie" : "Ajouter une partie"}
            open={open}
            onClose={() => setOpen(false)}
            width={900}
            destroyOnHidden
            extra={
                <Button type="primary" loading={loading} onClick={() => form.submit()}>
                    Enregistrer
                </Button>
            }
        >
            <Form form={form} onFinish={onSubmit} layout="vertical">
                <Form.Item name="title" label="Titre" rules={[{ required: true, message: "Le titre est obligatoire" }]}>
                    <Input placeholder="Ex : Préparation de l'ongle naturel" />
                </Form.Item>

                <Form.Item
                    name="is_free_preview"
                    label="Aperçu gratuit"
                    valuePropName="checked"
                    extra="Visible sur le portail sans achat, pour donner envie."
                >
                    <Switch />
                </Form.Item>

                <Form.Item name="content" label="Contenu (texte du manuel)">
                    <RichTextEditor />
                </Form.Item>

                <Alert
                    type="info"
                    showIcon
                    message="La vidéo se gère depuis la liste des parties (colonne Vidéo)."
                />
            </Form>
        </Drawer>
    );
};

export default PartForm;
